import React from 'react';
import type { ConnectionStatus } from '../services/gateway/types';

export type { ConnectionStatus };

interface StatusBarProps {
  status: ConnectionStatus;
}

const statusConfig: Record<ConnectionStatus, { color: string; label: string }> = {
  connected: { color: '#33AA40', label: 'Connected via Gateway' },
  connecting: { color: '#F5A623', label: 'Connecting...' },
  disconnected: { color: '#999999', label: 'Disconnected' },
  error: { color: '#FF5656', label: 'Connection Error' },
  fallback: { color: '#F5A623', label: 'Offline Mode' },
  basic: { color: '#999999', label: 'Basic Chat' },
};

const StatusBar: React.FC<StatusBarProps> = ({ status }) => {
  const config = statusConfig[status];

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 16px',
    backgroundColor: '#2B3B44',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
    fontSize: '12px',
    color: '#ffffff',
  };

  const dotStyle: React.CSSProperties = {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: config.color,
    animation: status === 'connecting' ? 'equanaut-pulse 1.5s infinite' : undefined,
    boxShadow: status === 'connected' ? `0 0 4px ${config.color}` : undefined,
  };

  const labelStyle: React.CSSProperties = {
    color: config.color,
    fontWeight: 500,
  };

  return (
    <>
      <style>
        {`
          @keyframes equanaut-pulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.5; transform: scale(0.8); }
          }
        `}
      </style>
      <div style={containerStyle}>
        <div style={dotStyle} />
        <span style={labelStyle}>{config.label}</span>
      </div>
    </>
  );
};

export default StatusBar;
